<template>
  <div class="error404">
    <div class="error404-body-con">
      <el-card class="box-card">
        <div class="error404-body-con-title">404</div>
        <div class="error404-main">找不到该页面</div>
        <div class="error404-btn-con">
          <el-button @click="goHome" style="font-size: 20px" type="primary" class="btn--green">返回首页</el-button>
          <el-button v-if="hasHistory" @click="backPage" style="margin-left: 40px;font-size: 20px;" type="text" class="color_green">返回上一页</el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error404",
  data() {
    return {
      hasHistory: true
    }
  },
  mounted() {
    this.hasHistory = document.referrer == '';
  },
  methods: {
    backPage() {
      console.log(document.referrer)
      this.$router.go(-1);
    },
    goHome() {
      this.$router.push({
        path: "/"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@keyframes error404animation {
  0% {
    transform: rotateZ(0deg);
  }
  20% {
    transform: rotateZ(-60deg);
  }
  40% {
    transform: rotateZ(-10deg);
  }
  60% {
    transform: rotateZ(50deg);
  }
  80% {
    transform: rotateZ(-20deg);
  }
  100% {
    transform: rotateZ(0deg);
  }
}
.error404 {
  &-body-con {
    width: 700px;
    height: 500px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    &-title {
      text-align: center;
      font-size: 180px;
      font-weight: 700;
      color: #ddd;
      height: 260px;
      line-height: 260px;
      margin-top: 40px;
      span {
        display: inline-block;
        color: #ddd;
        font-size: 200px;
        animation: error404animation 3s ease 0s infinite alternate;
      }
    }
    &-message {
      display: block;
      text-align: center;
      font-size: 30px;
      font-weight: 500;
      letter-spacing: 12px;
      color: #dddde2;
    }
  }
  &-main {
    margin-bottom: 20px;
    font-size: 24px;
    text-align: center;
    font-weight: bold;
    color: #4682b4;
    letter-spacing: 1px;
  }
  &-btn-con {
    text-align: center;
    padding: 20px 0;
    margin-bottom: 40px;
  }
}
</style>
